import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/73_card_back_classic_red/73_card_back_classic_red"
 * Contains 1 texture(s)
 */
export class CardsBacks73CardBackClassicRedAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/73_card_back_classic_red/73_card_back_classic_red';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '73_classic_red.png'
    ] as const;
}
